import { prefix } from "../settings";
export var cName = "".concat(prefix, "-conversation");
export default cName;